const residenceDisplayToggle = document.querySelector('.js-display-toggle');

if(residenceDisplayToggle) {
  const checkbox = residenceDisplayToggle.getElementsByTagName('input');
  const displayModeTarget = document.querySelector('.js-display-target')
  let displayMode;

  checkbox[0].addEventListener('change', (evt) => {
    displayMode = checkbox[0].checked ? 'invest' : 'dwell';
    displayModeTarget.setAttribute('data-display', displayMode);
  })
}
